import { formatNumber } from "helpers/helpers";
import { useEffect, useState } from "react";
import ChangeIndicator from "../ChangeIndicator";
import "./style.scss";


const mock = {
  high: 14.98,
  low: 13.48,
  change: {
    amount: 1.5,
    percentage: 9.40
  },
  volume: 32606571.05,
  trades: 3231,
  marketcap: 5301939962
}

const MarketInfoBar = ({marketData}) => {
  
  const [marketInfo, setMarketInfo] = useState(null);

  useEffect(() => {
    if(marketData.pairs) {
      let today = Math.floor(new Date().getTime() / 1000);
      let yesterday = today - 60 * 60 * 24;
      fetch("https://public-api.birdeye.so/defi/ohlcv?address="+marketData.pairs.base.address+"&type=1D&time_from="+yesterday+"&time_to="+today,
      {
        headers: {
          "X-API-KEY": process.env.REACT_APP_CANDLESTICK_API_KEY,
        }
      }
      ).then(res => res.json()).then(response => {
        console.log("RESSS", response)
        let info = response.data.items[0];
        let high = info.h;
        let low = info.l;
        let change = {
          amount: info.c - info.o,
          percentage: (info.c / info.o) * 100 - 100
        }
        let volume = info.v;
        console.log("RESS",{
          high: high,
          low: low,
          change: change,
          volume: volume
        })
        setMarketInfo({
          high: high,
          low: low,
          change: change,
          volume: volume,
          close: info.c
        });
      })
    }
  },[marketData]);

  return <div className="marketInfoBar">

    <div className="marketInfoSection">
      <p className="title">
        24h High
      </p>
      <p className="value">
        {
          marketInfo ?
          "$" + formatNumber(marketInfo.high, 8)
          :
          <div className="skeleton"/>
        }
      </p>
    </div>

    <hr className="separator"/>

    <div className="marketInfoSection">
      <p className="title">
        24h Low
      </p>
      <p className="value">
        {
          marketInfo ?
          "$" + formatNumber(marketInfo.low, 8)
          :
          <div className="skeleton"/>
        }
      </p>
    </div>

    <hr className="separator"/>
    
    <div className="marketInfoSection">
      <p className="title">
        24h Change
      </p>
      <div className="value">
        {
          marketInfo ?
          <ChangeIndicator change={marketInfo.change}/>
          :
          <div className="skeleton"/>
        }
      </div>
    </div>

    <hr className="separator"/>
    
    <div className="marketInfoSection">
      <p className="title">
        24h Volume
      </p>
      <p className="value">
        {
          marketInfo ?
          "$" + formatNumber(marketInfo.volume * marketInfo.close, "auto")
          :
          <div className="skeleton"/>
        }
      </p>
    </div>

    <hr className="separator"/>
  </div>
}

export default MarketInfoBar;